import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api/http";
import "../../styles/profile/Change.css";

const ChangePassword = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
    confirm_new_password: "",
  });

  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((p) => ({ ...p, [name]: value }));
  };

  const toggleShowPassword = (passwordType) => {
    if (passwordType === "old_password") setShowOldPassword((v) => !v);
    if (passwordType === "new_password") setShowNewPassword((v) => !v);
    if (passwordType === "confirm_new_password") setShowConfirmPassword((v) => !v);
  };

  const parseApiError = (err) => {
    const data = err?.response?.data;

    if (!data) return err?.message || "A apărut o eroare.";

    if (data.detail) return data.detail;

    if (typeof data === "object") {
      const keys = Object.keys(data);
      if (keys.length) {
        const v = data[keys[0]];
        if (Array.isArray(v)) return v[0];
        if (typeof v === "string") return v;
      }
    }

    if (Array.isArray(data)) return data[0];

    return "A apărut o eroare.";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    if (formData.new_password !== formData.confirm_new_password) {
      setError("New password și confirmarea nu coincid.");
      return;
    }

    setSubmitting(true);
    try {
      const payload = {
        old_password: formData.old_password,
        new_password: formData.new_password,
        confirm_new_password: formData.confirm_new_password,
      };

      const res = await api.patch("/authen/change-password/", payload);

      setMessage(res?.data?.detail || "Parola a fost schimbată cu succes.");
      setError("");

      navigate("/");
    } catch (err) {
      console.error("Change password error:", err);
      setError(parseApiError(err));
      setMessage("");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="srChPwd_wrap">
      <div className="srChPwd_card">
        <div className="srChPwd_header">
          <h1 className="srChPwd_title">Change Password</h1>
          <p className="srChPwd_subtitle">Introdu parola veche și setează una nouă.</p>
        </div>

        <form onSubmit={handleSubmit} className="srChPwd_form" autoComplete="off">
          {/* OLD */}
          <div className="srChPwd_field">
            <label className="srChPwd_label" htmlFor="old_password">
              Old Password
            </label>

            <div className="srChPwd_inputWrap">
              <input
                id="old_password"
                type={showOldPassword ? "text" : "password"}
                name="old_password"
                placeholder="Old password"
                value={formData.old_password}
                onChange={handleChange}
                required
                className="srChPwd_input"
                autoComplete="current-password"
              />

              <button
                type="button"
                className={`srChPwd_toggle ${showOldPassword ? "is-on" : ""}`}
                onClick={() => toggleShowPassword("old_password")}
                aria-label={showOldPassword ? "Hide password" : "Show password"}
              >
                {showOldPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* NEW */}
          <div className="srChPwd_field">
            <label className="srChPwd_label" htmlFor="new_password">
              New Password
            </label>

            <div className="srChPwd_inputWrap">
              <input
                id="new_password"
                type={showNewPassword ? "text" : "password"}
                name="new_password"
                placeholder="New password"
                value={formData.new_password}
                onChange={handleChange}
                required
                className="srChPwd_input"
                autoComplete="new-password"
              />

              <button
                type="button"
                className={`srChPwd_toggle ${showNewPassword ? "is-on" : ""}`}
                onClick={() => toggleShowPassword("new_password")}
                aria-label={showNewPassword ? "Hide password" : "Show password"}
              >
                {showNewPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* CONFIRM */}
          <div className="srChPwd_field">
            <label className="srChPwd_label" htmlFor="confirm_new_password">
              Confirm New Password
            </label>

            <div className="srChPwd_inputWrap">
              <input
                id="confirm_new_password"
                type={showConfirmPassword ? "text" : "password"}
                name="confirm_new_password"
                placeholder="Confirm password"
                value={formData.confirm_new_password}
                onChange={handleChange}
                required
                className="srChPwd_input"
                autoComplete="new-password"
              />

              <button
                type="button"
                className={`srChPwd_toggle ${showConfirmPassword ? "is-on" : ""}`}
                onClick={() => toggleShowPassword("confirm_new_password")}
                aria-label={showConfirmPassword ? "Hide password" : "Show password"}
              >
                {showConfirmPassword ? "Hide" : "Show"}
              </button>
            </div>
          </div>

          {/* MESSAGES */}
          {message && <div className="srChPwd_alert srChPwd_alertSuccess">{message}</div>}
          {error && <div className="srChPwd_alert srChPwd_alertError">{error}</div>}

          {/* ACTIONS */}
          <div className="srChPwd_actions">
            <button type="submit" className="srChPwd_btn srChPwd_btnPrimary" disabled={submitting}>
              {submitting ? "Se salvează..." : "Confirm"}
            </button>

            <button
              type="button"
              className="srChPwd_btn srChPwd_btnGhost"
              onClick={() => navigate(-1)}
              disabled={submitting}
            >
              Back
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangePassword;